import api from '@/api';

const { $academic, $pricing } = api;

export const { $degrees } = $academic;
export const { $types } = $pricing;
